import type { IndexUiState } from 'instantsearch.js'
import { useEffect, useMemo } from 'react'
import {
  Configure,
  InstantSearch,
  type InstantSearchProps
} from 'react-instantsearch'
import createSearchClient from '../../../../assets/utils/algolia/createSearchClient'
import SearchUI from './SearchUI'
import { useAppSelector } from '../store/hooks'
import type { IndexName } from '../types'

const instantSearchProps = {
  future: {
    preserveSharedStateOnUnmount: true
  },
  insights: false
} as const satisfies Partial<InstantSearchProps>

type TUiState = {
  [key in IndexName]: IndexUiState
}

export type AppProps<TRouteState = TUiState> = {
  routing?: InstantSearchProps<TUiState, TRouteState>['routing']
}

export default function App<TRouteState = TUiState>({
  routing
}: AppProps<TRouteState>) {
  const config = useAppSelector((state) => state.config)
  const searchClient = useMemo(() => {
    return createSearchClient(config.appId, config.apiKey)
  }, [config.appId, config.apiKey])

  const preFilterLocationType = useAppSelector(
    (state) => state.filter.preFilterLocationType
  )

  return (
    <InstantSearch
      {...instantSearchProps}
      indexName={config.indexName}
      routing={routing}
      searchClient={searchClient}
    >
      <Configure
        hitsPerPage={1000}
        getRankingInfo
        filters={
          preFilterLocationType ? `status:${preFilterLocationType}` : undefined
        }
      />
      <SearchUI />
    </InstantSearch>
  )
}
